export const getStandardIssueTemplate = (name: string) => {
  return {
    name: name,
    Items: [
      {
        itemMetadata: {
          id: 'GLOBAL_Issue_Title',
          name: 'Title',
          type: 'text'
        },
        formType: {
          value: 'TextForm',
          formLabel: 'Title for issue',
          multiple: false
        },
        required: true
      },
      {
        itemMetadata: {
          id: 'GLOBAL_Issue_Description',
          name: 'Description',
          type: 'text'
        },
        formType: {
          value: 'TextForm',
          formLabel: 'Description for issue',
          multiple: false
        },
        required: true
      },
      {
        itemMetadata: {
          id: 'GLOBAL_PhotoUrl',
          name: 'Document with photo',
          type: 'Text'
        },
        formType: {
          value: 'PhotoUpload',
          formLabel: 'Add Photo',
          multiple: true
        },
        required: false
      },
      {
        itemMetadata: {
          id: 'GLOBAL_TechnicalArea',
          name: 'GLOBAL_TechnicalArea',
          tenantSpecific: false,
          type: 'Options',
          typeParameters: {},
          optionSettings: {
            enabled: true,
            options: [
              {
                value: 'Architecture',
                label: null
              },
              {
                value: 'Ventilation',
                label: null
              },
              {
                value: 'Acoustics',
                label: null
              },
              {
                value: 'Construction',
                label: null
              },
              {
                value: 'Control and surveillance',
                label: null
              },
              {
                value: 'Cooling',
                label: null
              },
              {
                value: 'Electricity',
                label: null
              },
              {
                value: 'Elevator',
                label: null
              },
              {
                value: 'Fire',
                label: null
              },
              {
                value: 'Heating and sanitation',
                label: null
              },
              {
                value: 'Landscaping',
                label: null
              },
              {
                value: 'Plumbing',
                label: null
              },
              {
                value: 'Project shared',
                label: null
              },
              {
                value: 'Sprinkler',
                label: null
              }
            ]
          },
          readonly: false
        },
        formType: {
          value: 'Option',
          multiple: false
        },
        required: true
      }
    ]
  };
};

export const getStandardWorkflowTemplate = (
  issueTemplateId: string,
  name: string
) => {
  return {
    name,
    issueTemplateId,
    metadata: [],
    stateSettings: {
      startState: 2,
      endState: 6,
      states: [
        {
          name: '🚀 START',
          state: 2,
          canTransitionTo: []
        },
        {
          name: '⚙️ IN PROGRESS',
          state: 3,
          canTransitionTo: []
        },
        {
          name: '🔥 SUPER IMPORTANT',
          state: 4,
          canTransitionTo: []
        },
        {
          name: '🚒 PUTTING OUT FIRE',
          state: 5,
          canTransitionTo: []
        },
        {
          name: '🥳 DONE!!! aaabbb',
          state: 6,
          canTransitionTo: []
        }
      ]
    },
    filterOptions: [
      {
        filter: 'Assignee'
      },
      {
        filter: 'Category'
      },
      {
        filter: 'FreeText'
      },
      {
        filter: 'State'
      },
      {
        filter: 'Removed'
      }
    ],
    contentGroupSettings: {
      contentGroupTypeEnum: 'UserDefined',
      contentGroup: 'GLOBAL_IssuesUserDefined'
    },
    tenantSpecific: true
  };
};

export const getStandardTabTemplate = (
  name: string,
  workflowTemplateId: string,
  originTabTemplateId?: string
) => {
  return {
    country: null,
    name,
    shortName: null,
    translationKey: null,
    type: 'Checklist',
    alwaysActive: false,
    defaultActive: false,
    positionLocked: false,
    binderRoleType: null,
    settings: [
      {
        name: 'originTabTemplateId',
        value: originTabTemplateId ?? null
      },
      {
        name: 'workflowTemplateId',
        value: workflowTemplateId
      }
    ],
    metadataRequiredForUpload: [
      {
        required: true,
        isDocumentMetadata: true,
        value: 'TEMPLATE_GenerateBinderId',
        valueId: null,
        metadataElementId: 'GLOBAL_BinderId'
      },
      {
        required: false,
        isDocumentMetadata: false,
        value: null,
        valueId: null,
        metadataElementId: 'GLOBAL_Version'
      },
      {
        required: false,
        isDocumentMetadata: false,
        value: null,
        valueId: null,
        metadataElementId: 'GLOBAL_Description'
      }
    ],
    metadataUsedForFilter: [
      {
        value: 'TEMPLATE_GenerateBinderId',
        valueId: null,
        metadataElementId: 'GLOBAL_BinderId'
      },
      {
        value: 'TEMPLATE_GenerateTabId',
        valueId: null,
        metadataElementId: 'GLOBAL_TabId'
      },
      {
        value: 'Checklist',
        valueId: null,
        metadataElementId: 'GLOBAL_TabType'
      },
      {
        value: null,
        valueId: null,
        metadataElementId: 'GLOBAL_WorkflowId'
      }
    ],
    metadataUsedForDisplay: [],
    metadataAddedToAll: [],
    subtabSettings: [],
    groupByMetadataElementId: null,
    tenantSpecific: true,
    securityContext: null,
    templateDescription: null,
    templateTranslationKey: null,
    hasData: false
  };
};
